import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerToggle, MatDateRangeInput, MatDateRangePicker, MatEndDate, MatStartDate } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CorePipesModule } from '@sla-ng/core';
import { GenericDaterangeInputModule } from '@sla-ng/ui-material';
import { ProductionPage } from './production.page';

export * from './production.page';

const routes: Routes = [
    {
        path: '',
        component: ProductionPage,
    },
];

@NgModule({
    declarations: [ ProductionPage ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        MatCheckboxModule,
        ReactiveFormsModule,
        MatProgressBarModule,
        MatSortModule,
        MatTableModule,
        CorePipesModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        TranslateModule,
        GenericDaterangeInputModule,
        MatPaginatorModule,
        MatTooltipModule,
        MatMomentDateModule,
        MatDateRangeInput,
        MatDateRangePicker,
        MatDatepickerToggle,
        MatEndDate,
        MatStartDate,
    ],
    providers: [
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    ],
})
export class ProductionPageModule {
}
